import * as ST from './styled';
import { getTextWithTag } from '~/src/helpers/getTextWithTag';

interface IProps {
    blockId: string;
    title: string;
    desc: string;
    customStyles?: ST.IBgBlockStyles;
    background?: string;
    additionalBlockConfig?: any;
    tag?: string;
}

const BlockWithBg = ({ blockId, title, desc, customStyles, background, additionalBlockConfig, tag }: IProps): JSX.Element => {
    const titleWithTag = getTextWithTag(title, tag);

    return (
        <ST.Wrapper id={blockId} background={background} {...customStyles} {...additionalBlockConfig}>
            <ST.Grid modeName='wide'>
                <ST.Row>
                    <ST.Title {...customStyles} dangerouslySetInnerHTML={{ __html: titleWithTag }} />
                    <ST.Description {...customStyles} dangerouslySetInnerHTML={{ __html: desc }} />
                </ST.Row>
            </ST.Grid>
        </ST.Wrapper>
    );
};

export default BlockWithBg;
